<template>
  <div class="tilt_tabs w-full flex items-end">
    <!-- 左边tab -->
    <div
      :class="['tab_item', currentTab === tabData[0].key ? 'tab-left-active' : 'tab-left-not']"
      :style="leftTabStyle"
      @click="changeTab(tabData[0].key)">
      <div class="left-title">
        <div v-if="$slots.leftTitle"><slot name="leftTitle" /></div>
        <div class="text-medium leading-22 font-semibold" v-else>{{tabData[0].title}}</div>
      </div>
      <div class="left-sub-title subTitle">
        <div v-if="$slots.leftSubTitle"><slot name="leftSubTitle" /></div>
        <div v-else-if="tabData[0].subTitle">{{tabData[0].subTitle}}</div>
      </div>
    </div>

    <div class="relative">
      <div
        :class="[currentTab === tabData[0].key ? 'tab-center-left' : 'tab-center-right', 'tab-center']"
        :style="triangleStyle">
        <div class="top-ball" :style="topBallStyle">
          <div :style="{background: activeBgColor}"></div>
        </div>
        <div class="bottom-ball" :style="bottomBallStyle">
          <div :style="{background: defaultBgColor}"></div>
        </div>
      </div>
    </div>

    <!-- 右边tab -->
    <div
      :class="['tab_item', currentTab === tabData[1].key ? 'tab-right-active' : 'tab-right-not']" 
      :style="rightTabStyle"
      @click="changeTab(tabData[1].key)">
      <div class="right-title">
        <div v-if="$slots.rightTitle"><slot name="rightTitle" /></div>
        <div class="text-medium leading-22 font-semibold" v-else>{{tabData[1].title}}</div>
      </div>
      <div class="right-sub-title subTitle">
        <div v-if="$slots.rightSubTitle"><slot name="rightSubTitle" /></div>
        <div v-else-if="tabData[1].subTitle">{{tabData[1].subTitle}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TiltTabs",
  model: {
    prop: 'currentTab',
    event: 'click-tab',
  },
  props: {
    tabData: { // (必传)
      type: Array,
      default: () => []
    },
    currentTab: {
      type: String,
      default: ''
    },
    tiltAngle: { // 倾斜角度为三角形的宽(必传)
      type: Number,
      default: 62
    },
    activeHeight: { // 选中时的tab高度(必传)
      type: Number,
      default: 62
    },
    defaultHeight: { // 未选中时的tab高度(必传)
      type: Number,
      default: 46
    },
    activeBgColor: { // 选中时的tab背景颜色[单色背景] 和 中间倾斜图形的颜色[渐变背景](必传)
      type: String,
      default: ''
    },
    defaultBgColor: { // 未选中时的tab背景颜色
      type: String,
      default: '#EEEEEE'
    },
    activeLeftBgImage: { // 选中时的tab背景
      type: String,
      default: ''
    },
    activeRightBgImage: { // 选中时的tab背景
      type: String,
      default: ''
    },
    leftBottomBallPosition: { // 左下角球的位置
      type: Object,
      default: {}
    },
    rightBottomBallPosition: { // 右下角球的位置
      type: Object,
      default: {}
    },
  },
  computed: {
    triangleStyle() {
      if(this.currentTab === this.tabData[0].key) {
        return {
          'border-bottom': `${this.activeHeight}px solid ${this.activeBgColor}`,
          'border-right': `${this.tiltAngle}px solid transparent`
        }
      } else {
        return {
          'border-bottom': `${this.activeHeight}px solid ${this.activeBgColor}`,
          'border-left': `${this.tiltAngle}px solid transparent`,
          left: `-${this.tiltAngle - 1}px`
        }
      }
    },
    leftTabStyle() {
      if(this.currentTab === this.tabData[0].key) {
        return {
          height: `${this.activeHeight}px`,
          background: this.activeLeftBgImage || this.activeBgColor
        }
      } else {
        return {
          height: `${this.defaultHeight}px`,
          background: this.defaultBgColor
        }
      }
    },
    rightTabStyle() {
      if(this.currentTab === this.tabData[1].key) {
        return {
          height: `${this.activeHeight}px`,
          background: this.activeRightBgImage || this.activeBgColor
        }
      } else {
        return {
          height: `${this.defaultHeight}px`,
          background: this.defaultBgColor
        }
      }
    },
    topBallStyle() {
      if(this.currentTab === this.tabData[0].key) {
        return {
          background: `linear-gradient(225deg, ${this.defaultBgColor} 8px, ${this.activeBgColor} 4px)`
        }
      } else {
        return {
          background: `linear-gradient(-225deg, ${this.defaultBgColor} 8px, ${this.activeBgColor} 4px)`
        }
      }
    },
    bottomBallStyle() {
      if(this.currentTab === this.tabData[0].key) {
        return {
          background: `linear-gradient(45deg, ${this.activeBgColor} 8px, ${this.defaultBgColor} 4px)`,
          ...this.leftBottomBallPosition
        }
      } else {
        return {
          background: `linear-gradient(315deg, ${this.activeBgColor} 8px, ${this.defaultBgColor} 4px)`,
          ...this.rightBottomBallPosition
        }
      }
    }
  },
  methods: {
    changeTab(key) {
      this.$emit('click-tab', key)
    }
  },
}
</script>

<style scoped lang="scss">
.tilt_tabs {
  .tab_item {
    @apply flex flex-col items-center justify-center cursor-pointer box-border text-center relative leading-22;
    .subTitle {
      font-size: 10px;
      line-height: 10px;
    }
  }
  .tab-left-active {
    @apply rounded-tl-lg py-3 text-white;
    width: calc(50% - 5px);
    .subTitle {
      @apply  opacity-75 mt-1;
    }
  }
  .tab-left-not {
    @apply rounded-tl-lg text-theme-black-450;
    height: 46px;
    width: calc(50% - 5px);
    padding: 8px 0 6px 0;
    .subTitle {
      @apply  text-theme-black-350;
    }
  }
  .tab-right-active {
    @apply rounded-tr-lg py-3 text-white;
    width: calc(50% + 5px);
    .subTitle {
      @apply  opacity-75 mt-1;
    }
  }
  .tab-right-not {
    @apply rounded-tr-lg text-theme-black-450;
    height: 46px;
    width: calc(50% + 5px);
    padding: 8px 0 6px 0;
    .subTitle {
      @apply  text-theme-black-350;
    }
  }

  .tab-center {
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 10;
    .top-ball {
      position: absolute;
      top: 0;
      left: -18px;
      width: 20px;
      height: 20px;
      z-index: 10;
      div {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }
    .bottom-ball {
      position: absolute;
      top: 20px;
      width: 20px;
      height: 20px;
      z-index: 10;
      div {
        width: 100%;
        height: 100%;
        border-radius: 15px;
      }
    }
    &.tab-center-right {
      .top-ball {
        left: -2px;
      }
    }
  }
}
</style>
